import { FunctionComponent } from "react";

interface Props {
  className?: string;
}

/**
 * IAB CCPA "Your Privacy Choices" icon (blue toggle with check and X).
 */
const PrivacyChoicesIcon: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 14"
    width="30"
    height="14"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="30" height="14" rx="7" fill="#0A57FA" />
    <rect x="1" y="1" width="13" height="12" rx="6" fill="#fff" />
    <path d="M10.4 3.6 6.9 7.1 5.1 5.3 4 6.4l2.9 2.9 4.7-4.7z" fill="#0A57FA" />
    <path
      d="m20.3 4.1-1.3 1.3 2.6 2.6-2.6 2.6 1.3 1.3 2.6-2.6 2.6 2.6 1.3-1.3-2.6-2.6 2.6-2.6-1.3-1.3-2.6 2.6z"
      fill="#fff"
    />
  </svg>
);

export default PrivacyChoicesIcon;
